import { Component, OnInit} from '@angular/core';
import { ScriptsModule } from '../../../modules/scripts.module';
import { ActivatedRoute, Router } from '@angular/router';
import { IntermService } from '../../../services/general/interm.service';
import { Intermediario }    from '../../../obj/intermediario';
import { connectableObservableDescriptor } from 'rxjs/observable/ConnectableObservable';
import { jsonpFactory } from '@angular/http/src/http_module';

declare var jquery:any;
declare var $ :any;


@Component({
  selector: 'app-comision',
  templateUrl: './comision.component.html',
  styleUrls: ['./comision.component.css'],
  providers: [IntermService]
})
export class ComisionComponent implements OnInit {

  public modelUser;
  public modelInter;
  public model;
  public IdResponsable;
  public urlReporte;

  constructor(private route: ActivatedRoute,private router: Router,private int:IntermService) {

  }

  ngOnInit(){
      let scripts = new ScriptsModule;
      // scripts.loadScript('assets/js/jquery.dataTables.js');
      // scripts.loadScript('assets/js/dataTables.bootstrap.min.js');
      scripts.loadScript('assets/js/slider_fss.js');
      scripts.loadScript('assets/js/jquery.mousewheel.min.js');
      scripts.loadScript('assets/js/scripts/intermediarios-plataforma.js');

      var usuario=  localStorage.getItem('currentUsuario');
      //ACA SE DEBE CONTROLAR LOS EMAILS ENVIADOS
      if(usuario==null)
        this.router.navigate(['/intermediarios']);
      else{
        this.modelUser=JSON.parse(usuario);
        this.modelInter= new Intermediario();

        this.model={codigo:"",identificacion:""};
        this.cargarComisiones();
      }

    }

    cargarComisiones(){
      this.model.idUsuario=this.modelUser.idIntermediario;
      this.int.getComisiones(JSON.stringify(this.model)).then(resc => {
          this.modelInter.comisiones=resc;
        });
    }

    abrirReporteComision(){

      if((this.model.inicio!= undefined && this.model.inicio!="") && (this.model.fin!=undefined && this.model.fin!="")){
        debugger
        this.urlReporte = 'http://35.83.60.73:82/ReportServer/Pages/ReportViewer.aspx?/ServidorInformes/ListadoGralComisionesExternosInt&rs:Command=Render&Responsable=' + this.modelUser.id+"&Intermediario="+this.modelUser.idIntermediario+"&FInicial="+this.model.inicio+"&FFinal="+this.model.fin;
        window.open(this.urlReporte,  "_blank");
      }
      else{
        alert("Debe seleccionar las fechas para generar el reporte ")
      }

    }

    descargarComision(c){
      var ancho=800;
      var alto=500;
      var posicion_x;
      var posicion_y;
      posicion_x=(screen.width/2)-(ancho/2);
      posicion_y=(screen.height/2)-(alto/2);
      console.log(c.codigo)
      window.open('https://embeddedapi.segurosmedicosinternacionales.com.co/reporte/comision/'+c.codigo, "", ",menubar=0,toolbar=0,directories=0,scrollbars=no,resizable=no,left="+posicion_x+",top="+posicion_y+"");
    }
}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/comision/comision.component.ts